import Vue from "vue";
import ApiService from "../../services/ApiService";
import { EventBus, EVENTS } from "../../services/EventBus";

Vue.component("player-comparison-widget", {
  delimiters: ["${", "}"],

  props: {
    leftPlayer: {
      type: Object,
      required: true,
    },
    rightPlayer: {
      type: Object,
      required: true,
    },
    thirdPlayer: {
      type: Object,
      required: false,
      default: null,
    },
    leftPlayerSofascoreWidget: {
      type: String,
      required: false,
      default: "",
    },
    rightPlayerSofascoreWidget: {
      type: String,
      required: false,
      default: "",
    },
    thirdPlayerSofascoreWidget: {
      type: String,
      required: false,
      default: "",
    },
    consentTitle: {
      type: String,
      default: "SofaScore Widget laden",
    },
    consentMessage: {
      type: String,
      default: "Mit dem Laden des SofaScore Widgets akzeptieren Sie die Datenschutzbestimmungen von SofaScore.",
    },
    consentButtonText: {
      type: String,
      default: "Widget laden",
    },
    orText: {
      type: String,
      default: "oder",
    },
    voteLeftText: {
      type: String,
      default: "Für diesen Spieler stimmen",
    },
    voteRightText: {
      type: String,
      default: "Für diesen Spieler stimmen",
    },
    voteThirdText: {
      type: String,
      default: "Für diesen Spieler stimmen",
    },
    currentVotesText: {
      type: String,
      default: "Aktuelle Stimmen",
    },
  },

  data() {
    return {
      leftVotes: 0,
      rightVotes: 0,
      thirdVotes: 0,
      totalVotes: 0,
      userVote: null, // "left", "right", "third" oder null
      isLoading: false,
      message: "",
      isLoggedIn: false,
      technicalDataCollapsed: {
        left: true,
        right: true,
        third: true,
      },
    };
  },

  computed: {
    leftVotePercentage() {
      if (this.totalVotes === 0) return this.thirdPlayer ? 33.33 : 50;
      return Math.round((this.leftVotes / this.totalVotes) * 100);
    },
    rightVotePercentage() {
      if (this.totalVotes === 0) return this.thirdPlayer ? 33.33 : 50;
      return Math.round((this.rightVotes / this.totalVotes) * 100);
    },
    thirdVotePercentage() {
      if (this.totalVotes === 0) return 33.33;
      return Math.round((this.thirdVotes / this.totalVotes) * 100);
    },
    hasUserVoted() {
      return this.userVote !== null;
    },
    leftPlayerName() {
      return this.leftPlayer?.texts?.[0]?.name1 || "Spieler A";
    },
    rightPlayerName() {
      return this.rightPlayer?.texts?.[0]?.name1 || "Spieler B";
    },
    thirdPlayerName() {
      return this.thirdPlayer?.texts?.[0]?.name1 || "Spieler C";
    },
    leftPlayerPosition() {
      return this.getPropertyValue(this.leftPlayer, 73) || "";
    },
    rightPlayerPosition() {
      return this.getPropertyValue(this.rightPlayer, 73) || "";
    },
    thirdPlayerPosition() {
      return this.getPropertyValue(this.thirdPlayer, 73) || "";
    },
    leftPlayerMarketValue() {
      const value = this.getPropertyValue(this.leftPlayer, 58);
      return value ? Number(value).toLocaleString("de-DE") + "€" : "";
    },
    rightPlayerMarketValue() {
      const value = this.getPropertyValue(this.rightPlayer, 58);
      return value ? Number(value).toLocaleString("de-DE") + "€" : "";
    },
    thirdPlayerMarketValue() {
      const value = this.getPropertyValue(this.thirdPlayer, 58);
      return value ? Number(value).toLocaleString("de-DE") + "€" : "";
    },
    leftPlayerUrl() {
      return this.getPlayerUrl(this.leftPlayer);
    },
    rightPlayerUrl() {
      return this.getPlayerUrl(this.rightPlayer);
    },
    thirdPlayerUrl() {
      return this.getPlayerUrl(this.thirdPlayer);
    },
    leftPlayerTechnicalData() {
      return this.getTechnicalData(this.leftPlayer);
    },
    rightPlayerTechnicalData() {
      return this.getTechnicalData(this.rightPlayer);
    },
    thirdPlayerTechnicalData() {
      return this.getTechnicalData(this.thirdPlayer);
    },
  },

  created() {
  },

  mounted() {
    if (typeof window !== "undefined") {
      this.loadVotes();
      this.checkLoginStatus();
    }
  },

  methods: {
    loadVotes() {
      const params = {
        leftPlayerId: this.leftPlayer.item?.id,
        rightPlayerId: this.rightPlayer.item?.id,
      };
      if (this.thirdPlayer) {
        params.thirdPlayerId = this.thirdPlayer.item?.id;
      }
      ApiService.get("/rest/fanliebling/player-comparison/votes", params)
        .done((response) => {
          this.leftVotes = response.leftVotes || 0;
          this.rightVotes = response.rightVotes || 0;
          this.thirdVotes = response.thirdVotes || 0;
          this.totalVotes = response.totalVotes || 0;
          this.userVote = response.userVote || null;
          this.isLoggedIn = response.userVote !== null || response.isLoggedIn === true;
        })
        .fail((error) => {
          this.checkLoginStatus();
        })
        .always(() => {
          this.isLoading = false;
        });
    },

    checkLoginStatus() {
      if (this.$store && this.$store.state && this.$store.state.user) {
        this.isLoggedIn = !!this.$store.state.user.isLoggedIn;
      }
    },

    openLoginModal() {
      const loginButton = document.querySelector('.control-user a[data-toggle="modal"]');
      if (loginButton) {
        loginButton.click();
      }
    },

    vote(side) {
      if (this.isLoading || !this.isLoggedIn) {
        if (!this.isLoggedIn) {
          this.openLoginModal();
        }
        return;
      }

      this.isLoading = true;
      this.message = "";

      const payload = {
        leftPlayerId: this.leftPlayer.item?.id,
        rightPlayerId: this.rightPlayer.item?.id,
        vote: side, // "left", "right" or "third"
      };
      if (this.thirdPlayer) {
        payload.thirdPlayerId = this.thirdPlayer.item?.id;
      }
      ApiService.post("/rest/fanliebling/player-comparison/vote", payload)
        .done((response) => {
          const data = response.data || response;

          if (data && data.leftVotes !== undefined) {
            this.$set(this, "leftVotes", parseInt(data.leftVotes) || 0);
            this.$set(this, "rightVotes", parseInt(data.rightVotes) || 0);
            this.$set(this, "thirdVotes", parseInt(data.thirdVotes) || 0);
            this.$set(this, "totalVotes", parseInt(data.totalVotes) || 0);
            this.$set(this, "userVote", data.userVote || null);

            this.message = "Vielen Dank für deine Stimme!";

            // Event auslösen für Badge-Update
            EventBus.$emit(EVENTS.INTERACTION_COMPLETED);

            setTimeout(() => {
              this.message = "";
            }, 3000);
          } else {
            this.message = "Ein Fehler ist aufgetreten.";
          }
        })
        .fail((error) => {
          this.loadVotes();
        })
        .always(() => {
          this.isLoading = false;
        });
    },

    voteLeft() {
      this.vote("left");
    },

    voteRight() {
      this.vote("right");
    },

    voteThird() {
      this.vote("third");
    },

    getPlayerUrl(player) {
      if (!player) return "#";
      
      const itemId = player.item?.id || 0;
      const variationId = player.variation?.id || player.ids?.variation || player.id || 0;
      
      if (player.texts?.[0]?.urlPath && itemId > 0 && variationId > 0) {
        return "/" + player.texts[0].urlPath + "_" + itemId + "_" + variationId;
      }
      
      if (variationId > 0 && itemId > 0) {
        const itemName = player.texts?.[0]?.name1 || "";
        
        if (itemName) {
          const slug = itemName.toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
          return `/${slug}_${itemId}_${variationId}`;
        }
        
        return `/item-${itemId}`;
      }
      
      return "#";
    },

    getPropertyValue(player, propertyId) {
      if (!player?.variationProperties) {
        return null;
      }
      
      for (let i = 0; i < player.variationProperties.length; i++) {
        const vprop = player.variationProperties[i];
        
        if (vprop.property && vprop.property.id === propertyId) {
          let value = null;
          
          if (vprop.values && Array.isArray(vprop.values) && vprop.values[0]) {
            value = vprop.values[0].value;
          }
          
          if (!value && vprop.values?.names?.value) {
            value = vprop.values.names.value;
          }
          
          if (!value && vprop.property?.values?.value) {
            value = vprop.property.values.value;
          }
          
          if (!value && vprop.property?.value) {
            value = vprop.property.value;
          }
          
          return value;
        }
        
        if (vprop.properties) {
          const result = vprop.properties.find((prop) => prop.id === propertyId);
          if (result?.values) {
            return result.values.value || null;
          }
        }
      }
      
      return null;
    },

    getTechnicalData(player) {
      if (!player) return null;
      
      if (player.texts && player.texts[0]) {
        const text = player.texts[0];
        
        if (text.technicalData) {
          return text.technicalData;
        }
        
        if (text.description2) {
          return text.description2;
        }
      }
      
      return null;
    },

    toggleTechnicalData(position) {
      this.$set(this.technicalDataCollapsed, position, !this.technicalDataCollapsed[position]);
    },

    isMobile() {
      // SSR-safe: Return false on server, check window only on client
      if (typeof window === "undefined") {
        return false;
      }
      return window.innerWidth < 768;
    },

    renderPlayerCard(player, voteText, voteMethod, voteValue) {
      const playerName = player === this.leftPlayer ? this.leftPlayerName : 
                        player === this.rightPlayer ? this.rightPlayerName : 
                        this.thirdPlayerName;
      const playerPosition = player === this.leftPlayer ? this.leftPlayerPosition : 
                            player === this.rightPlayer ? this.rightPlayerPosition : 
                            this.thirdPlayerPosition;
      const playerMarketValue = player === this.leftPlayer ? this.leftPlayerMarketValue : 
                               player === this.rightPlayer ? this.rightPlayerMarketValue : 
                               this.thirdPlayerMarketValue;
      const playerUrl = player === this.leftPlayer ? this.leftPlayerUrl : 
                       player === this.rightPlayer ? this.rightPlayerUrl : 
                       this.thirdPlayerUrl;
      const playerTechnicalData = player === this.leftPlayer ? this.leftPlayerTechnicalData : 
                                 player === this.rightPlayer ? this.rightPlayerTechnicalData : 
                                 this.thirdPlayerTechnicalData;

      // SofaScore Widget für jeweiligen Spieler ermitteln
      const sofascoreWidget = player === this.leftPlayer ? this.leftPlayerSofascoreWidget :
                             player === this.rightPlayer ? this.rightPlayerSofascoreWidget :
                             this.thirdPlayerSofascoreWidget;

      const h = this.$createElement;
      
      // Leistungsdaten-Section: entweder SofaScore Widget mit Consent oder normale Leistungsdaten
      let performanceDataSection = null;
      
      if (sofascoreWidget && sofascoreWidget.trim()) {
        // SofaScore Widget vorhanden - zeige iframe-consent-wrapper
        performanceDataSection = h("div", { class: "sofascore-widget mb-3" }, [
          h("h5", { 
            class: "font-weight-bold h4 text-left mb-2"
          }, "Leistungsdaten"),
          h("iframe-consent-wrapper", {
            props: {
              content: sofascoreWidget.trim(),
              title: this.consentTitle,
              message: this.consentMessage,
              buttonText: this.consentButtonText,
              storageKey: "sofascore_consent_global"
            }
          })
        ]);
      } else if (playerTechnicalData) {
        // Keine Widget - zeige normale Leistungsdaten
        performanceDataSection = h("div", { class: "technical-data mb-3" }, [
          h("h5", { 
            class: "font-weight-bold h4 text-left mb-2 d-flex align-items-center justify-content-between",
            style: "cursor: pointer;",
            on: {
              click: () => this.toggleTechnicalData(voteValue),
            },
          }, [
            "Leistungsdaten",
            h("i", { 
              class: this.technicalDataCollapsed[voteValue] ? "fa fa-chevron-down d-lg-none" : "fa fa-chevron-up d-lg-none",
            }),
          ]),
          h("div", {   
            class: this.technicalDataCollapsed[voteValue] ? "d-none d-lg-block" : "",               
            domProps: {
              innerHTML: playerTechnicalData,
            },
          }),
        ]);
      }

      return h("div", { class: `col-12 ${this.thirdPlayer ? 'col-lg-4' : 'col-lg-5'}` }, [
        h("div", { class: "player-card border border-radius p-3 text-center position-relative" }, [
          h("h3", { class: "h2 mb-3" }, playerName),

          playerPosition
            ? h("p", { class: "mb-2" }, [
                h("i", { class: "fa fa-map-marker mr-2" }),
                "Position: " + playerPosition,
              ])
            : null,

          playerMarketValue
            ? h("p", { class: "font-weight-bold mb-3" }, [
                "Marktwert: " + playerMarketValue,
              ])
            : null,

          h(
            "a",
            {
              class: "btn btn-outline-primary btn-sm mb-3 d-inline-flex align-items-center",
              attrs: {
                href: playerUrl,                
              },
            },
            [
            "Zum Spieler",
              h("i", { class: "fa fa-arrow-right mr-2" }),              
            ]
          ),

          performanceDataSection,

          h(
            "button",
            {
              class: {
                "btn": true,
                "btn-primary": this.userVote !== voteValue,
                "btn-success": this.userVote === voteValue,
                "btn-block": true,
                "btn-lg": true,
              },
              attrs: {
                disabled: this.isLoading || !this.isLoggedIn,
              },
              on: {
                click: voteMethod,
              },
            },
            [
              h("i", { class: this.userVote === voteValue ? "fa fa-check-circle mr-2" : "fa fa-check mr-2" }),
              this.userVote === voteValue ? "Deine Wahl" : voteText,
            ]
          ),
        ]),
      ]);
    },
  },

  render: function(h) {
    const players = [this.renderPlayerCard(this.leftPlayer, this.voteLeftText, this.voteLeft, "left")];
    
    if (!this.thirdPlayer) {
      players.push(
        h("div", { class: "col-12 col-lg-2 text-center my-3 my-lg-0" }, [
          h("span", { class: "h2 font-weight-bold" }, this.orText),
        ])
      );
    } else {
      players.push(
        h("div", { class: "col-12 col-lg-auto text-center my-2 my-lg-0 d-flex align-items-center justify-content-center" }, [
          h("span", { class: "h2 font-weight-bold mx-2" }, this.orText),
        ])
      );
    }

    players.push(this.renderPlayerCard(this.rightPlayer, this.voteRightText, this.voteRight, "right"));

    if (this.thirdPlayer) {
      players.push(
        h("div", { class: "col-12 col-lg-auto text-center my-2 my-lg-0 d-flex align-items-center justify-content-center" }, [
          h("span", { class: "h2 font-weight-bold mx-2" }, this.orText),
        ])
      );
      players.push(this.renderPlayerCard(this.thirdPlayer, this.voteThirdText, this.voteThird, "third"));
    }

    return h("div", { class: "player-comparison-widget" }, [
      this.message
        ? h("div", { 
            class: "alert alert-success text-center mb-2 py-2 px-3",
            style: { fontSize: "0.85rem" }
          }, this.message)
        : null,

      h("div", { class: "row align-items-center" }, players),

      !this.isLoggedIn && !this.hasUserVoted
        ? h("div", { 
            class: "alert alert-info text-center mt-4 py-2 px-3",
            style: { fontSize: "0.85rem" }
          }, [
            h("i", { class: "fa fa-info-circle mr-2" }),
            "Bitte ",
            h(
              "a",
              {
                attrs: { href: "#" },
                on: { click: (e) => { e.preventDefault(); this.openLoginModal(); } },
              },
              "melde dich an"
            ),
            ", um abzustimmen.",
          ])
        : null,

      this.totalVotes > 0
        ? h("div", { class: "vote-results mt-4" }, [
            h("h4", { class: "text-center mb-3" }, this.currentVotesText),
            h("div", { class: "row" }, [
              h("div", { class: `col-${this.thirdPlayer ? '4' : '6'} text-center` }, [
                h("div", { class: "h1 font-weight-bold text-primary" }, `${this.leftVotes}`),
                h("div", { class: "" }, `${this.leftVotePercentage}%`),
                h("div", { class: "progress mt-2", style: { height: "30px" } }, [
                  h("div", {
                    class: "progress-bar bg-primary",
                    style: { width: `${this.leftVotePercentage}%` },
                    attrs: {
                      role: "progressbar",
                      "aria-valuenow": this.leftVotePercentage,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                    },
                  }),
                ]),
              ]),

              h("div", { class: `col-${this.thirdPlayer ? '4' : '6'} text-center` }, [
                h("div", { class: "h1 font-weight-bold text-primary" }, `${this.rightVotes}`),
                h("div", { class: "" }, `${this.rightVotePercentage}%`),
                h("div", { class: "progress mt-2", style: { height: "30px" } }, [
                  h("div", {
                    class: "progress-bar bg-primary",
                    style: { width: `${this.rightVotePercentage}%` },
                    attrs: {
                      role: "progressbar",
                      "aria-valuenow": this.rightVotePercentage,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100",
                    },
                  }),
                ]),
              ]),

              this.thirdPlayer
                ? h("div", { class: "col-4 text-center" }, [
                    h("div", { class: "h1 font-weight-bold text-primary" }, `${this.thirdVotes}`),
                    h("div", { class: "" }, `${this.thirdVotePercentage}%`),
                    h("div", { class: "progress mt-2", style: { height: "30px" } }, [
                      h("div", {
                        class: "progress-bar bg-primary",
                        style: { width: `${this.thirdVotePercentage}%` },
                        attrs: {
                          role: "progressbar",
                          "aria-valuenow": this.thirdVotePercentage,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100",
                        },
                      }),
                    ]),
                  ])
                : null,
            ]),

            h("div", { class: "text-center mt-3 small" }, `Gesamt: ${this.totalVotes} Stimmen`),
          ])
        : null,
    ]);
  },
});
